import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const update = async (data: FormData) => {
  const response: TServerResponse = await request({
    url: apiUrls.blogs.UPDATE_BLOGS,
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const useUpdateBlogsMutation = () => {
  return useMutation({ mutationFn: update });
};
